declare namespace $ {

	export class $brbr_brbr_button extends $mol_button_major {
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map